<div class="bg-white"><Header></Header><main><slot></slot></main><Footer></Footer></div>